import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import {withStyles} from 'material-ui/styles/index'
import Container from '../../../common/components/Container'
import Typography from 'material-ui/Typography'
import {Frame} from '../../../components'
import {help as text} from '../text'

const FAQS_IMAGE = '/assets/noActivities.png'
const CHAT_IMAGE = '/assets/noActivities.png'
const CONTACT_IMAGE = '/assets/noActivities.png'

const
  styles = theme => ({
    topBanner: {
      marginTop: 0,
      background: theme.palette.primary.main,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        marginTop: -47,
      },
    },
    title: {
      fontWeight: 300,
      color: '#FFF',
      paddingTop: 50,
    },
    subtitle1: {
      fontWeight: 400,
      color: '#FFF',
      paddingBottom: 5,
    },
    subtitle2: {
      fontWeight: 300,
      color: '#FFF',
      paddingBottom: 50,
    },
    container: {
      paddingTop: 50,
      paddingBottom: 75,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
      },
    },
    frame: {
      flex: 1,
      maxWidth: 500,
      marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.up('lg')]: {
        maxWidth: 'auto',
        margin: 10,
      },
    },
  })

class Help extends React.Component {

  handleChat = () => {
    window.LC_API.open_chat_window()
  }

  render() {
    const {classes} = this.props
    return (
      <div>
        <div className={classes.topBanner}>
          <Typography variant={'display1'} className={classes.title} gutterBottom={true}>{text.title}</Typography>
          <Typography variant={'heading'} className={classes.subtitle1}>{text.subtitle1}</Typography>
          <Typography variant={'subheading'} className={classes.subtitle2}>{text.subtitle2}</Typography>
        </div>
        <Container>
          <div className={classes.container}>
            <Frame image={FAQS_IMAGE} className={classes.frame}
                   text={text.faqs.title} buttonText={text.faqs.button}
                   onClick={() => this.props.history.push('/ayuda/faqs')}
            />

            <Frame image={CHAT_IMAGE} className={classes.frame}
                   text={text.chat.title}
                   buttonText={text.chat.button}
                   onClick={this.handleChat}
                   helperText={this.props.isChatDisabled ? text.chat.error : ''}
                   buttonProps={{disabled: this.props.isChatDisabled}}
            />

            <Frame image={CONTACT_IMAGE} className={classes.frame}
                   text={text.contact.title} buttonText={text.contact.button}
                   onClick={() => this.props.history.push('/ayuda/contacto')}
            />
          </div>
        </Container>
      </div>
    )
  }

  static propTypes = {
    isChatDisabled: PropTypes.bool.isRequired,
  }
}

export default compose(withStyles(styles, {withTheme: true}))(Help)



// WEBPACK FOOTER //
// ./src/sections/help/components/help.js